/* iz-motion.js · Inzinnergy scroll motion engine (≈2.5 KB, no dependencies).
   Compositor-safe: only transform/opacity are animated. Honours prefers-reduced-motion.
   Hooks (data attributes):
     data-iz-reveal            → adds .is-in when 12% visible; [data-iz-stagger] children get --i
     data-iz-parallax="0.12"   → translateY drift relative to viewport centre (speed = factor)
     data-iz-progress          → sets --p (0→1) as the element travels from viewport bottom to centre
     data-iz-marquee           → duplicates the track once for a seamless CSS loop
*/
(function () {
  if (window.__izMotion) return; window.__izMotion = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var doc = document;

  function stagger(root) {
    var kids = root.querySelectorAll('[data-iz-stagger]');
    for (var i = 0; i < kids.length; i++) kids[i].style.setProperty('--i', String(i));
  }

  function init(scope) {
    scope = scope || doc;
    /* marquee: clone track content once */
    var mq = scope.querySelectorAll('[data-iz-marquee]:not([data-iz-ready])');
    for (var m = 0; m < mq.length; m++) {
      var track = mq[m].querySelector('.iz-marquee__track');
      if (track) { track.insertAdjacentHTML('beforeend', track.innerHTML); }
      mq[m].setAttribute('data-iz-ready', '1');
    }
    /* reveals */
    var rev = scope.querySelectorAll('[data-iz-reveal]:not([data-iz-ready])');
    for (var r = 0; r < rev.length; r++) {
      stagger(rev[r]); rev[r].setAttribute('data-iz-ready', '1');
      if (reduce || !('IntersectionObserver' in window)) { rev[r].classList.add('is-in'); } else { io.observe(rev[r]); }
    }
    /* parallax + progress */
    var px = scope.querySelectorAll('[data-iz-parallax]:not([data-iz-ready]), [data-iz-progress]:not([data-iz-ready])');
    for (var p = 0; p < px.length; p++) {
      px[p].setAttribute('data-iz-ready', '1');
      if (reduce) { px[p].style.setProperty('--p', '1'); continue; }
      tracked.push(px[p]); vis.observe(px[p]);
    }
    tick();
  }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    for (var i = 0; i < es.length; i++) if (es[i].isIntersecting) { es[i].target.classList.add('is-in'); io.unobserve(es[i].target); }
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }) : null;

  var tracked = [], active = [], raf = 0;
  var vis = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    for (var i = 0; i < es.length; i++) {
      var el = es[i].target, idx = active.indexOf(el);
      if (es[i].isIntersecting) { if (idx < 0) active.push(el); } else if (idx > -1) { active.splice(idx, 1); }
    }
    tick();
  }, { rootMargin: '20% 0px 20% 0px' }) : null;

  function tick() { if (!raf) raf = requestAnimationFrame(update); }
  function update() {
    raf = 0;
    var vh = window.innerHeight || doc.documentElement.clientHeight;
    for (var i = 0; i < active.length; i++) {
      var el = active[i], rect = el.getBoundingClientRect();
      var f = parseFloat(el.getAttribute('data-iz-parallax'));
      if (!isNaN(f)) {
        var d = (rect.top + rect.height / 2) - vh / 2;   /* px from viewport centre */
        el.style.transform = 'translate3d(0,' + (-d * f).toFixed(1) + 'px,0)';
      }
      if (el.hasAttribute('data-iz-progress')) {
        var mode = el.getAttribute('data-iz-progress');
        var pr = mode === 'line' ? (vh * 0.62 - rect.top) / rect.height : mode === 'enter' ? (vh - rect.top) / Math.min(rect.height, vh * 0.45) : (vh - rect.top) / (vh / 2 + rect.height / 2);
        pr = pr < 0 ? 0 : pr > 1 ? 1 : pr;
        el.style.setProperty('--p', pr.toFixed(3));
      }
    }
  }
  window.addEventListener('scroll', tick, { passive: true });
  window.addEventListener('resize', tick);

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  /* Shopify theme editor: re-init on section load */
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.izMotionInit = init;
})();
